import { useSelector } from 'react-redux'
const base = process.env.API_URL || 'https://ada-api.securitas.es/api'

/**
 * Download the user active activity to .xlsx file
 * contains the name specified and the current date
 * @param slug the slugged id of the client
 * @param name start of filename
 */
export const useExportUserData = (slug: number, name: string) => {
  const token = useSelector((s:any) => s.user.token)

  return async () => {
    const today = new Date().toISOString().slice(0, 10)

    const filename = `${name}_${today}.xlsx`

    const res = await fetch(base + '/client/user/' + slug + '/active/activity/export/xlsx', {
      headers: { Authorization: 'Bearer ' + token }
    })

    const blob = await res.blob()
    const a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(blob)
    a.download = filename
    a.click()
  }
}

/**
 * Download the assetActivity with the date formated
 * @param slug the slugged id of the client
 * @param name start of filename
 */
export const useExportAssetData = (slug: string, name: string) => {
  const token = useSelector((s:any) => s.user.token)

  return async () => {
    const today = new Date().toISOString().slice(0, 10)

    const filename = `${name}_${today}.xlsx`

    const res = await fetch(base + '/client/active/' + slug + '/activity/export/xlsx', {
      headers: { Authorization: 'Bearer ' + token }
    })

    const blob = await res.blob()
    const a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(blob)
    a.download = filename
    a.click()
  }
}
